<div
  class="container-fluid pt-3 pb-1 flex flex-col flex-1 min-h-0 overflow-auto"
>
  <ng-container *ngIf="!!table; else noTable">
    <div class="jumbotron p-3">
      <div
        class="select-filters mb-5"
        *ngIf="table.getName() === 'project_user'"
      >
        <mat-form-field appearance="outline" class="mr-2">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            name="clienteSelect"
            [(ngModel)]="usuarioCliente"
            (selectionChange)="usuarioClienteChange()"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.ALL_CLIENTS' | translate }}
            </mat-option>
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        class="select-filters mb-5"
        *ngIf="
          table.getName() === 'project_module' ||
          table.getName() === 'project_sensor'
        "
      >
        <mat-form-field appearance="outline" class="mr-2">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            name="clienteSelect"
            [(ngModel)]="cliente"
            (selectionChange)="clienteChange($event.value)"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.ALL_CLIENTS' | translate }}
            </mat-option>
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'TABLES.PROJECT_FINCA._LABEL' | translate }}</mat-label>
          <mat-select
            name="fincaSelect"
            [(ngModel)]="finca"
            (selectionChange)="fincaChange($event.value)"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.ALL_FARMS' | translate }}
            </mat-option>
            <mat-option *ngFor="let finca of fincas" [value]="finca.idFinca">
              {{ finca.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Sensor module filter -->
        <mat-form-field
          appearance="outline"
          class="ml-2"
          *ngIf="table.getName() === 'project_sensor'"
        >
          <mat-label>{{
            'TABLES.PROJECT_MODULE._LABEL' | translate
          }}</mat-label>
          <mat-select
            name="moduloSelect"
            [(ngModel)]="sensorFiltroModulo"
            (selectionChange)="sensorFiltroModuloChange($event.value)"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.ALL_MODULES' | translate }}
            </mat-option>
            <mat-option
              *ngFor="let modulo of sensorFiltroModulos"
              [value]="modulo.idModule"
            >
              {{ modulo.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="select-filters mb-5"
        *ngIf="table.getName() === 'project_finca'"
      >
        <mat-form-field appearance="outline" class="mr-2">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            name="fincaClienteSelect"
            [(ngModel)]="fincaFiltroCliente"
            (selectionChange)="fincaClienteChange()"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.ALL_CLIENTS' | translate }}
            </mat-option>
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        class="select-filters mb-5"
        *ngIf="table.getName() === 'project_moisture_profile'"
      >
        <mat-form-field appearance="outline" class="mr-2">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            name="clientePerfilSelect"
            [(ngModel)]="moistureProfileFiltroCliente"
            (selectionChange)="moistureProfileClienteChange()"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.ALL_CLIENTS' | translate }}
            </mat-option>
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="table-responsive px-3">
        <div class="table-header">
          <div>
            <h3 class="mb-3">{{ table.getLabel() | translate }}</h3>
          </div>
          <div *ngIf="showCreateButton">
            <button
              mat-fab
              color="primary"
              aria-label="Crear"
              (click)="create()"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <app-smart-table
          [settings]="settings"
          [source]="data"
          (deleteConfirm)="onDeleteConfirm($event)"
          (editConfirm)="onSaveConfirm($event)"
          (createConfirm)="onCreateConfirm($event)"
          (create)="create($event)"
          (edit)="edit($event)"
          (delete)="onDeleteConfirm($event)"
          (toggle)="onToggle($event)"
          (alarmFinca)="onAlarmFinca($event)"
        ></app-smart-table>
      </div>
    </div>
  </ng-container>
  <ng-template #noTable>
    <div class="row justify-content-center">
      <div class="col-auto">
        <p class="text-muted font-italic">{{ 'COMMON.LOADING' | translate }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template #usuarioForm>
    <h2 mat-dialog-title>{{ formTitle }} Usuario</h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field appearance="outline">
          <mat-label>Usuario telegram*</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="usuarioNombre"
            name="usuarioNombre"
            autocomplete="off"
          />
        </mat-form-field>

        <div *ngIf="formTitle === 'Editar'" class="dialog-section">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rol</mat-label>
            <mat-select
              name="usuarioRolId"
              [(ngModel)]="usuarioRolId"
              [disabled]="usuarioRoleLoading"
            >
              <mat-option
                *ngFor="let role of usuarioRoleOptions"
                [value]="role.id"
              >
                {{ role.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="role-hint" *ngIf="usuarioRoleError">
            {{ usuarioRoleError }}
          </div>
        </div>

        <div *ngIf="formTitle === 'Editar'" class="dialog-section">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Asociar a cliente</mat-label>
            <mat-select
              placeholder="Cliente..."
              name="usuarioAsociar"
              [(ngModel)]="usuarioAsociar"
            >
              <mat-option disabled [value]="-1">
                Seleccionar cliente...
              </mat-option>
              <mat-option
                *ngFor="let cliente of clientes"
                [value]="cliente.idCliente"
              >
                {{ cliente.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="btn-asociar">
            <button mat-flat-button color="primary" (click)="asociarCliente()">
              Asociar
            </button>
          </div>

          <ul class="clientes-asignados" *ngIf="usuarioClientesAsignados.length">
            <li
              *ngFor="let c of usuarioClientesAsignados"
              class="cliente-asignado-item"
            >
              <span>{{ c.name }}</span>
              <button
                mat-icon-button
                color="warn"
                type="button"
                (click)="desasociarCliente(c.idCliente)"
                aria-label="Desasociar"
              >
                <mat-icon>close</mat-icon>
              </button>
            </li>
          </ul>
        </div>

        <div *ngIf="formTitle === 'Editar'" class="dialog-section weekly-report-admin-section">
          <div class="weekly-report-admin-header">
            <div>
              <h3>{{ 'WEEKLY_REPORTS.TITLE' | translate }}</h3>
              <p>{{ 'WEEKLY_REPORTS.INTRO' | translate }}</p>
              <p>
                {{ 'WEEKLY_REPORTS.SENDS_TO' | translate }}:
                <strong>{{ editData?.email || '-' }}</strong>
              </p>
            </div>
          </div>

          <div class="weekly-report-loading" *ngIf="usuarioWeeklyReportLoading">
            {{ 'WEEKLY_REPORTS.LOADING' | translate }}
          </div>

          <ng-container *ngIf="!usuarioWeeklyReportLoading">
            <div
              class="weekly-report-errors"
              *ngIf="usuarioWeeklyReportErrors.length"
            >
              <div *ngFor="let error of usuarioWeeklyReportErrors">
                {{ error }}
              </div>
            </div>

            <div class="weekly-report-grid">
              <div class="weekly-report-toggle-row">
                <mat-checkbox [(ngModel)]="usuarioWeeklyReportForm.enabled" name="usuarioWeeklyReportEnabled">
                  {{ 'WEEKLY_REPORTS.ENABLED' | translate }}
                </mat-checkbox>
              </div>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.PLAN' | translate }}</mat-label>
                <mat-select [(ngModel)]="usuarioWeeklyReportForm.plan" name="usuarioWeeklyReportPlan">
                  <mat-option
                    *ngFor="let option of usuarioWeeklyReportPlanOptions"
                    [value]="option.value"
                  >
                    {{ option.labelKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.SCOPE' | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="usuarioWeeklyReportForm.scopeType"
                  name="usuarioWeeklyReportScopeType"
                  (selectionChange)="onUsuarioWeeklyReportScopeChange()"
                >
                  <mat-option
                    *ngFor="let option of usuarioWeeklyReportScopeOptions"
                    [value]="option.value"
                  >
                    {{ option.labelKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.SEND_DAY' | translate }}</mat-label>
                <mat-select [(ngModel)]="usuarioWeeklyReportForm.sendDay" name="usuarioWeeklyReportSendDay">
                  <mat-option
                    *ngFor="let option of usuarioWeeklyReportDayOptions"
                    [value]="option.value"
                  >
                    {{ option.labelKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.SEND_TIME' | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="usuarioWeeklyReportForm.sendTime"
                  name="usuarioWeeklyReportSendTime"
                >
                  <mat-option
                    *ngFor="let time of getUsuarioWeeklyReportSendTimeOptions()"
                    [value]="time"
                  >
                    {{ time }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.TIMEZONE' | translate }}</mat-label>
                <mat-select [(ngModel)]="usuarioWeeklyReportForm.timezone" name="usuarioWeeklyReportTimezone">
                  <mat-option
                    *ngFor="let timezone of usuarioWeeklyReportTimezoneOptions"
                    [value]="timezone"
                  >
                    {{ timezone }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.LANGUAGE' | translate }}</mat-label>
                <mat-select [(ngModel)]="usuarioWeeklyReportForm.language" name="usuarioWeeklyReportLanguage">
                  <mat-option
                    *ngFor="let option of usuarioWeeklyReportLanguageOptions"
                    [value]="option.value"
                  >
                    {{ option.labelKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="weekly-report-plan-cards">
              <div
                class="weekly-report-plan-card"
                *ngFor="let option of usuarioWeeklyReportPlanOptions"
              >
                <div class="weekly-report-plan-title">
                  {{ option.labelKey | translate }}
                </div>
                <div class="weekly-report-plan-description">
                  {{ option.descriptionKey | translate }}
                </div>
              </div>
            </div>

            <div
              class="weekly-report-scope-select"
              *ngIf="usuarioWeeklyReportForm.scopeType === 'selected_clients'"
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.CLIENTS' | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="usuarioWeeklyReportForm.clientIds"
                  name="usuarioWeeklyReportClientIds"
                  multiple
                >
                  <mat-option
                    *ngFor="let client of usuarioClientesAsignados"
                    [value]="client.idCliente"
                  >
                    {{ client.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="weekly-report-scope-select"
              *ngIf="usuarioWeeklyReportForm.scopeType === 'selected_fincas'"
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ 'WEEKLY_REPORTS.FINCAS' | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="usuarioWeeklyReportForm.fincaIds"
                  name="usuarioWeeklyReportFincaIds"
                  multiple
                >
                  <mat-option
                    *ngIf="!getUsuarioWeeklyReportFincas().length"
                    disabled
                  >
                    {{ 'WEEKLY_REPORTS.NO_FINCAS' | translate }}
                  </mat-option>
                  <mat-option
                    *ngFor="let finca of getUsuarioWeeklyReportFincas()"
                    [value]="finca.idFinca"
                  >
                    {{ getUsuarioWeeklyReportFincaLabel(finca) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="weekly-report-actions-card">
              <div class="weekly-report-actions-header">
                <div>
                  <div class="weekly-report-actions-title">
                    {{ 'WEEKLY_REPORTS.MANUAL_ACTIONS' | translate }}
                  </div>
                  <div class="weekly-report-actions-text">
                    {{ 'WEEKLY_REPORTS.MANUAL_RUN_HELP' | translate }}
                  </div>
                </div>
                <mat-form-field appearance="outline" class="weekly-report-week-field">
                  <mat-label>{{ 'WEEKLY_REPORTS.WEEK_START' | translate }}</mat-label>
                  <input
                    matInput
                    readonly
                    [matDatepicker]="weeklyReportWeekStartPicker"
                    [ngModel]="usuarioWeeklyReportRunWeekStartDate"
                    (ngModelChange)="onUsuarioWeeklyReportWeekStartChange($event)"
                    (click)="weeklyReportWeekStartPicker.open()"
                    name="usuarioWeeklyReportRunWeekStart"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="weeklyReportWeekStartPicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #weeklyReportWeekStartPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="weekly-report-actions-grid">
                <button
                  mat-flat-button
                  color="primary"
                  type="button"
                  (click)="saveUsuarioWeeklyReport()"
                  [disabled]="usuarioWeeklyReportSaving"
                >
                  {{ 'COMMON.SAVE' | translate }}
                </button>

                <button
                  mat-stroked-button
                  type="button"
                  (click)="previewUsuarioWeeklyReportPayload()"
                  [disabled]="usuarioWeeklyReportSaving || usuarioWeeklyReportPreviewLoading"
                >
                  {{ 'WEEKLY_REPORTS.PREVIEW_PAYLOAD' | translate }}
                </button>

                <button
                  mat-stroked-button
                  type="button"
                  (click)="runUsuarioWeeklyReportManually()"
                  [disabled]="usuarioWeeklyReportSaving || usuarioWeeklyReportRunLoading"
                >
                  {{ 'WEEKLY_REPORTS.RUN_MANUAL' | translate }}
                </button>

                <button
                  mat-stroked-button
                  type="button"
                  (click)="openUsuarioWeeklyReportHtmlPreview()"
                  [disabled]="!usuarioWeeklyReportLastRunId || usuarioWeeklyReportHtmlLoading"
                >
                  {{ 'WEEKLY_REPORTS.OPEN_HTML' | translate }}
                </button>

                <button
                  mat-stroked-button
                  type="button"
                  (click)="generateUsuarioWeeklyReportPdf()"
                  [disabled]="!usuarioWeeklyReportLastRunId || usuarioWeeklyReportPdfLoading"
                >
                  {{ 'WEEKLY_REPORTS.GENERATE_PDF' | translate }}
                </button>

                <button
                  mat-stroked-button
                  type="button"
                  (click)="downloadUsuarioWeeklyReportPdf()"
                  [disabled]="!usuarioWeeklyReportLastRunId || usuarioWeeklyReportPdfLoading"
                >
                  {{ 'WEEKLY_REPORTS.DOWNLOAD_PDF' | translate }}
                </button>

                <button
                  mat-stroked-button
                  type="button"
                  (click)="resendUsuarioWeeklyReportEmail()"
                  [disabled]="!usuarioWeeklyReportLastRunId || usuarioWeeklyReportEmailLoading"
                >
                  {{ 'WEEKLY_REPORTS.RESEND_EMAIL' | translate }}
                </button>
              </div>

              <div class="weekly-report-run-meta" *ngIf="usuarioWeeklyReportLastRunId">
                {{ 'WEEKLY_REPORTS.LAST_RUN' | translate }}:
                <strong>#{{ usuarioWeeklyReportLastRunId }}</strong>
              </div>
            </div>

            <div
              class="weekly-report-preview-card"
              *ngIf="usuarioWeeklyReportPreviewPayload"
            >
              <div class="weekly-report-preview-title">
                {{ 'WEEKLY_REPORTS.PREVIEW_PAYLOAD' | translate }}
              </div>
              <pre>{{ usuarioWeeklyReportPreviewPayload }}</pre>
            </div>
          </ng-container>
        </div>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="saveUsuarioDialog()"
      >
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #clienteForm>
    <h2 mat-dialog-title>{{ formTitle }} Cliente</h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>{{ 'COMMON.NAME' | translate }}*</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteNombre"
            name="clienteNombre"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Teléfono*</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteTelefono"
            name="clienteTelefono"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Email*</mat-label>
          <input
            matInput
            matInput
            type="email"
            [(ngModel)]="clienteEmail"
            name="clienteEmail"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Ciudad</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteCiudad"
            name="clienteCiudad"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Dirección</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteDireccion"
            name="clienteDireccion"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>País</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clientePais"
            name="clientePais"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Provincia</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteProvincia"
            name="clienteProvincia"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>CP</mat-label>
          <input
            matInput
            matInput
            type="number"
            [(ngModel)]="clienteCP"
            name="clienteCP"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Nombre contacto</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteContacto"
            name="clienteContacto"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Empresa</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteEmpresa"
            name="clienteEmpresa"
            autocomplete="off"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>CIF</mat-label>
          <input
            matInput
            matInput
            [(ngModel)]="clienteCIF"
            name="clienteCIF"
            autocomplete="off"
          />
        </mat-form-field>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="clienteSave(); dialogRef?.close()"
      >
        Guardar
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #fincaForm>
    <h2 mat-dialog-title>
      {{
        formTitle === 'Crear'
          ? ('COMMON.CREATE' | translate)
          : ('COMMON.EDIT' | translate)
      }}
      {{ 'TABLES.PROJECT_FINCA._LABEL' | translate }}
    </h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field
          appearance="outline"
          class="w-100 dialog-first-field"
          floatLabel="always"
        >
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            id="cliente"
            [(ngModel)]="fincaCliente"
            name="fincaCliente"
          >
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'COMMON.NAME' | translate }}*</mat-label>
          <input
            matInput
            id="name"
            [(ngModel)]="fincaNombre"
            name="fincaNombre"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'TABLES.PROJECT_FINCA.CITY' | translate }}*</mat-label>
          <input
            matInput
            id="city"
            [(ngModel)]="fincaPoblacion"
            name="fincaPoblacion"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{ 'TABLES.PROJECT_FINCA.LATITUDE' | translate }}*</mat-label
          >
          <input
            matInput
            type="number"
            id="lat"
            [(ngModel)]="fincaLat"
            name="fincaLat"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{ 'TABLES.PROJECT_FINCA.LONGITUDE' | translate }}*</mat-label
          >
          <input
            matInput
            type="number"
            id="lng"
            [(ngModel)]="fincaLng"
            name="fincaLng"
          />
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="fincaSave(); closeDialog()"
      >
        Guardar
      </button>
    </mat-dialog-actions>
  </ng-template>
  <ng-template #moduloForm>
    <h2 mat-dialog-title>
      {{
        formTitle === 'Crear'
          ? ('COMMON.CREATE' | translate)
          : ('COMMON.EDIT' | translate)
      }}
      {{ 'TABLES.PROJECT_MODULE._LABEL' | translate }}
    </h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field appearance="outline" class="w-100 dialog-first-field">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            id="cliente"
            [(ngModel)]="moduloCliente"
            name="moduloCliente"
            (selectionChange)="clienteChange(moduloCliente, true)"
          >
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'TABLES.PROJECT_FINCA._LABEL' | translate }}</mat-label>
          <mat-select id="finca" [(ngModel)]="moduloFinca" name="moduloFinca">
            <mat-option
              *ngIf="moduloFincas.length === 0"
              [value]="-1"
              disabled
              >{{ 'TABLES.FILTERS.NO_FARMS' | translate }}</mat-option
            >
            <mat-option
              *ngFor="let finca of moduloFincas"
              [value]="finca.idFinca"
            >
              {{ finca.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'COMMON.NAME' | translate }}</mat-label>
          <input
            matInput
            id="name"
            [(ngModel)]="moduloNombre"
            name="moduloNombre"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{ 'TABLES.PROJECT_MODULE.DEVICE_MAC' | translate }}*</mat-label
          >
          <input matInput id="mac" [(ngModel)]="moduloMac" name="moduloMac" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{ 'TABLES.PROJECT_MODULE.POWER_SUPPLY' | translate }}*</mat-label
          >
          <mat-select id="power" [(ngModel)]="moduloPower" name="moduloPower">
            <mat-option value="BA">{{
              'TABLES.PROJECT_MODULE.POWER_SUPPLY_BATTERY' | translate
            }}</mat-option>
            <mat-option value="EN">{{
              'TABLES.PROJECT_MODULE.POWER_SUPPLY_GRID' | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{
              'TABLES.PROJECT_MODULE.BATTERY_CAPACITY' | translate
            }}*</mat-label
          >
          <input
            matInput
            type="number"
            id="bateria"
            [(ngModel)]="moduloBateria"
            name="moduloBateria"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{
            'TABLES.PROJECT_MODULE.AEMET_CODE' | translate
          }}</mat-label>
          <input
            matInput
            id="aemetCode"
            [(ngModel)]="moduloAemetCode"
            name="moduloAemetCode"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{ 'TABLES.PROJECT_FINCA.LATITUDE' | translate }}*</mat-label
          >
          <input
            matInput
            type="number"
            id="lat"
            [(ngModel)]="moduloLat"
            name="moduloLat"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label
            >{{ 'TABLES.PROJECT_FINCA.LONGITUDE' | translate }}*</mat-label
          >
          <input
            matInput
            type="number"
            id="lng"
            [(ngModel)]="moduloLng"
            name="moduloLng"
          />
        </mat-form-field>

        <button
          type="button"
          mat-flat-button
          color="primary"
          class="my-4"
          (click)="openModuleSettings()"
        >
          {{ 'COMMON.ADDITIONAL_CONFIG' | translate }}
        </button>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="moduloSave(); closeDialog()"
      >
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>
  <ng-template #sensorForm>
    <h2 mat-dialog-title>
      {{
        formTitle === 'Crear'
          ? ('COMMON.CREATE' | translate)
          : ('COMMON.EDIT' | translate)
      }}
      {{ 'TABLES.PROJECT_SENSOR._LABEL' | translate }}
    </h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field appearance="outline" class="w-100 dialog-first-field">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            id="cliente"
            [(ngModel)]="sensorCliente"
            name="sensorCliente"
            (selectionChange)="sensorClienteChange(sensorCliente)"
          >
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'TABLES.PROJECT_FINCA._LABEL' | translate }}</mat-label>
          <mat-select
            id="finca"
            [(ngModel)]="sensorFinca"
            name="sensorFinca"
            (selectionChange)="sensorFincaChange()"
          >
            <mat-option
              *ngIf="sensorFincas.length === 0"
              [value]="-1"
              disabled
              >{{ 'TABLES.FILTERS.NO_FARMS' | translate }}</mat-option
            >
            <mat-option
              *ngFor="let finca of sensorFincas"
              [value]="finca.idFinca"
            >
              {{ finca.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{
            'TABLES.PROJECT_MODULE._LABEL' | translate
          }}</mat-label>
          <mat-select
            id="modulo"
            [(ngModel)]="sensorModulo"
            name="sensorModulo"
            [compareWith]="compareSelectValues"
            (selectionChange)="sensorModulo = $event.value"
          >
            <mat-option
              *ngIf="modulos.length === 0"
              [value]="-1"
              class="text-secondary"
              >{{ 'TABLES.FILTERS.NO_MODULES' | translate }}</mat-option
            >
            <mat-option
              *ngFor="let modulo of modulos"
              [value]="modulo.idModule"
            >
              {{ modulo.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{
            'TABLES.PROJECT_SENSOR.IS_ALARM_ENABLED' | translate
          }}</mat-label>
          <mat-select
            id="alarma"
            [(ngModel)]="sensorAlarma"
            name="sensorAlarma"
            [compareWith]="compareSelectValues"
            (selectionChange)="sensorAlarma = $event.value"
          >
            <mat-option [value]="false">{{
              'COMMON.NO' | translate
            }}</mat-option>
            <mat-option [value]="true">{{
              'COMMON.YES' | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{
            'TABLES.PROJECT_SENSOR.MINIMUN' | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            id="min"
            [(ngModel)]="sensorMin"
            name="sensorMin"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{
            'TABLES.PROJECT_SENSOR.MAXIMUN' | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            id="max"
            [(ngModel)]="sensorMax"
            name="sensorMax"
          />
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-100"
          *ngIf="formTitle === 'Editar' && isMoistureSensorType(sensorTipo)"
        >
          <mat-label>{{
            'TABLES.PROJECT_MOISTURE_PROFILE._LABEL' | translate
          }}</mat-label>
          <mat-select
            [formControl]="moistureProfileControl"
            [compareWith]="compareSelectValues"
          >
            <mat-option [value]="null">{{
              'COMMON.NONE' | translate
            }}</mat-option>
            <mat-option
              *ngFor="let profile of moistureProfiles"
              [value]="profile.id ?? profile.idMoistureProfile"
            >
              {{ profile.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="w-100"
          style="margin-bottom: 12px;"
        >
          <mat-label>{{
            'TABLES.PROJECT_SENSOR.SENSOR_TYPE' | translate
          }}</mat-label>
          <mat-select
            id="tipo"
            [(ngModel)]="sensorTipo"
            name="sensorTipo"
            [disabled]="formTitle === 'Editar'"
            [compareWith]="compareSelectValues"
            (selectionChange)="sensorTipo = $event.value"
          >
            <mat-option
              *ngFor="let sensorType of sensorTypes"
              [value]="sensorType.value"
            >
              {{ sensorType.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="formTitle === 'Editar'">
          <button
            type="button"
            mat-flat-button
            color="primary"
            class="my-4"
            (click)="openSensorSettings()"
            *ngIf="
              sensorTipo === 'CO' ||
              sensorTipo === 'FL' ||
              isMoistureSensorType(sensorTipo) ||
              sensorTipo === 'DE' ||
              sensorTipo === 'PL' ||
              sensorTipo === 'ED' ||
              sensorTipo === 'TE'
            "
          >
            {{ 'COMMON.ADDITIONAL_CONFIG' | translate }}
          </button>
        </ng-container>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="sensorSave(); closeDialog()"
        [disabled]="
          formTitle === 'Crear' && (sensorModulo === -1 || !sensorTipo)
        "
      >
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #moistureProfileForm>
    <h2 mat-dialog-title>
      {{
        formTitle === 'Crear'
          ? ('COMMON.CREATE' | translate)
          : ('COMMON.EDIT' | translate)
      }}
      {{ 'TABLES.PROJECT_MOISTURE_PROFILE._LABEL' | translate }}
    </h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field appearance="outline" class="w-100 dialog-first-field">
          <mat-label>{{
            'TABLES.PROJECT_CLIENTE._LABEL' | translate
          }}</mat-label>
          <mat-select
            [(ngModel)]="moistureProfileCliente"
            name="moistureProfileCliente"
            [compareWith]="compareSelectValues"
            (selectionChange)="moistureProfileCliente = $event.value"
          >
            <mat-option [value]="-1" class="text-secondary">
              {{ 'TABLES.FILTERS.SELECT_CLIENT' | translate }}
            </mat-option>
            <mat-option
              *ngFor="let cliente of clientes"
              [value]="cliente.idCliente"
            >
              {{ cliente.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'COMMON.NAME' | translate }}</mat-label>
          <input
            matInput
            [(ngModel)]="moistureProfileName"
            name="moistureProfileName"
            maxlength="100"
          />
          <mat-hint align="end"
            >{{ (moistureProfileName || '').length }}/100</mat-hint
          >
        </mat-form-field>
      </form>

      <div *ngIf="formTitle === 'Editar'" class="season-section">
        <div class="season-header">
          <h3>{{ 'TABLES.PROJECT_MOISTURE_PROFILE.SEASONS' | translate }}</h3>
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="openMoistureSeasonCreate()"
          >
            {{ 'COMMON.NEW_SEASON' | translate }}
          </button>
        </div>
        <div class="season-table-wrapper">
          <table class="season-table">
            <thead>
              <tr>
                <th>{{ 'COMMON.NAME' | translate }}</th>
                <th>
                  {{
                    'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_START' | translate
                  }}
                </th>
                <th>
                  {{ 'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_END' | translate }}
                </th>
                <th>
                  {{
                    'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_THRESHOLD1'
                      | translate
                  }}
                </th>
                <th>
                  {{
                    'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_THRESHOLD2'
                      | translate
                  }}
                </th>
                <th>
                  {{
                    'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_PRIORITY'
                      | translate
                  }}
                </th>
                <th>
                  {{
                    'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_ACTIVE' | translate
                  }}
                </th>
                <th class="season-actions-col">
                  {{
                    'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_ACTIONS' | translate
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let season of moistureProfileSeasons">
                <td>{{ season.name }}</td>
                <td>{{ season.startMmdd }}</td>
                <td>{{ season.endMmdd }}</td>
                <td>{{ season.threshold1 }}</td>
                <td>{{ season.threshold2 }}</td>
                <td>{{ season.priority }}</td>
                <td>
                  {{
                    season.isEnabled
                      ? ('COMMON.YES' | translate)
                      : ('COMMON.NO' | translate)
                  }}
                </td>
                <td class="season-actions">
                  <button
                    mat-icon-button
                    type="button"
                    (click)="openMoistureSeasonEdit(season)"
                    aria-label="Editar"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    (click)="deleteMoistureSeason(season)"
                    aria-label="Eliminar"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="moistureProfileSeasons.length === 0">
                <td class="season-empty" colspan="8">
                  {{ 'TABLES.PROJECT_MOISTURE_PROFILE.NO_SEASONS' | translate }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="moistureProfileSave(); closeDialog()"
        [disabled]="!isMoistureProfileValid()"
      >
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #confirmDialog>
    <h2 mat-dialog-title>{{ confirmTitleKey | translate }}</h2>
    <mat-dialog-content class="dialog-body">
      <p>{{ confirmMessageKey | translate }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="closeDialog()">
        {{ confirmCancelKey | translate }}
      </button>
      <button mat-flat-button color="warn" (click)="confirmDeleteSeason()">
        {{ confirmActionKey | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #moistureSeasonForm>
    <h2 mat-dialog-title>
      {{
        seasonFormTitle === 'Crear'
          ? ('COMMON.CREATE' | translate)
          : ('COMMON.EDIT' | translate)
      }}
      {{ 'TABLES.PROJECT_MOISTURE_PROFILE.SEASON' | translate }}
    </h2>
    <mat-dialog-content class="dialog-body">
      <form class="dialog-form">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'COMMON.NAME' | translate }}</mat-label>
          <input matInput [(ngModel)]="seasonName" name="seasonName" />
        </mat-form-field>

        <div class="season-form-row" appSeasonDateFormats>
          <mat-form-field appearance="outline">
            <mat-label>{{
              'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_START' | translate
            }}</mat-label>
            <input
              matInput
              [matDatepicker]="seasonStartPicker"
              [(ngModel)]="seasonStartDate"
              name="seasonStartDate"
              placeholder="MM-DD"
              (dateChange)="onSeasonStartDateChange($event.value)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="seasonStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #seasonStartPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{
              'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_END' | translate
            }}</mat-label>
            <input
              matInput
              [matDatepicker]="seasonEndPicker"
              [(ngModel)]="seasonEndDate"
              name="seasonEndDate"
              placeholder="MM-DD"
              (dateChange)="onSeasonEndDateChange($event.value)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="seasonEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #seasonEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="season-form-row">
          <mat-form-field appearance="outline">
            <mat-label>{{
              'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_THRESHOLD1' | translate
            }}</mat-label>
            <input
              matInput
              type="number"
              min="0"
              max="100"
              [(ngModel)]="seasonThreshold1"
              name="seasonThreshold1"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{
              'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_THRESHOLD2' | translate
            }}</mat-label>
            <input
              matInput
              type="number"
              min="0"
              max="100"
              [(ngModel)]="seasonThreshold2"
              name="seasonThreshold2"
            />
          </mat-form-field>
        </div>

        <div class="season-form-row">
          <mat-form-field appearance="outline">
            <mat-label>{{
              'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_PRIORITY' | translate
            }}</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="seasonPriority"
              name="seasonPriority"
            />
          </mat-form-field>
          <mat-checkbox [(ngModel)]="seasonEnabled" name="seasonEnabled">
            {{ 'TABLES.PROJECT_MOISTURE_PROFILE.SEASON_ACTIVE' | translate }}
          </mat-checkbox>
        </div>

        <div class="season-error" *ngIf="seasonError">{{ seasonError }}</div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="closeDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="moistureSeasonSave()"
        [disabled]="!isSeasonValid()"
      >
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #sensorSettingsForm>
    <h2 mat-dialog-title class="sensor-settings-title">
      {{ 'TABLES.SENSOR_SETTINGS.CONFIGURE_SENSOR' | translate }}
      <button
        mat-icon-button
        type="button"
        aria-label="Cerrar"
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content class="sensor-settings-body">
      <form>
        <div
          *ngIf="
            editData.sensorType === 'TE' ||
            editData.sensorType === 'HH' ||
            editData.sensorType === 'DE' ||
            editData.sensorType === 'PL'
          "
        >
          <h6 class="mb-4">
            {{ 'TABLES.SENSOR_SETTINGS.CALIBRATION_TITLE' | translate }}
          </h6>
          <div
            class="row"
            *ngFor="let sensorSetting of sensorSettings; let i = index"
          >
            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.CALIBRATION' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="sensorCalibracion{{ i }}"
                [(ngModel)]="sensorSettings[i].calibration"
                name="sensorCalibracion{{ i }}"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha{{ i }}"
                id="fecha{{ i }}"
                [(ngModel)]="sensorSettingsDates[i]"
                [matDatepicker]="pickerInst"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerInst"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerInst></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input
                matInput
                type="time"
                [(ngModel)]="sensorSettingsTimes[i]"
                name="hora{{ i }}"
              />
            </mat-form-field>

            <div class="col-sm-3 align-self-center relative-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
                <div class="col">
                  <small>{{ 'COMMON.DELETE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    (click)="saveSensorSetting(i)"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
                <div class="col">
                  <button
                    (click)="deleteSensorSetting(sensorSetting.idSettings)"
                    mat-icon-button
                    color="warn"
                  >
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.CALIBRATION' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="sensorCalibracion"
                [(ngModel)]="sensorCalibracion"
                name="sensorCalibracion"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha"
                id="fecha"
                [(ngModel)]="sensorFecha"
                [matDatepicker]="sensorDate2"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="sensorDate2"
              ></mat-datepicker-toggle>
              <mat-datepicker #sensorDate2></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input matInput type="time" [(ngModel)]="hora" name="hora" />
            </mat-form-field>

            <div class="col align-self-center relative-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    (click)="createSensorSetting()"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="editData.sensorType === 'CO'">
          <h6>{{ 'TABLES.SENSOR_SETTINGS.CONDUCTIVITY_TITLE' | translate }}</h6>
          <div
            class="row"
            *ngFor="let sensorSetting of sensorSettings; let i = index"
          >
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.ZERO_PERMITTIVITY' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="permitividad{{ i }}"
                [(ngModel)]="sensorSetting.co_permitivity"
                name="permitividad{{ i }}"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha{{ i }}"
                id="fecha{{ i }}"
                [(ngModel)]="sensorSettingsDates[i]"
                [matDatepicker]="pickerHU"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerHU"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerHU></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input
                matInput
                type="time"
                [(ngModel)]="sensorSettingsTimes[i]"
                name="hora{{ i }}"
              />
            </mat-form-field>

            <div class="col-sm-3 align-self-center relative-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
                <div class="col">
                  <small>{{ 'COMMON.DELETE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    (click)="saveSensorSetting(i)"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
                <div class="col">
                  <button
                    type="button"
                    (click)="deleteSensorSetting(sensorSetting.idSettings)"
                    mat-icon-button
                    color="warn"
                  >
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.ZERO_PERMITTIVITY' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="permitividad"
                [(ngModel)]="sensorPermitividad"
                name="permitividad"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha"
                id="fecha"
                [(ngModel)]="sensorFecha"
                [matDatepicker]="sensorDate3"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="sensorDate3"
              ></mat-datepicker-toggle>
              <mat-datepicker #sensorDate3></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input matInput type="time" [(ngModel)]="hora" name="hora" />
            </mat-form-field>

            <div class="col-sm-3 align-self-center relative-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    (click)="createSensorSetting()"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="editData.sensorType === 'FL'">
          <h6 class="mb-4">
            {{ 'TABLES.SENSOR_SETTINGS.FLOW_TITLE' | translate }}
          </h6>
          <div
            class="row"
            *ngFor="let sensorSetting of sensorSettings; let i = index"
          >
            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.DRIPPERS_PER_LINE' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="goterosLinea{{ i }}"
                [(ngModel)]="sensorSetting.fl_DrippersLine"
                name="goterosLinea{{ i }}"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.DRIPPERS_PER_TREE' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="goterosArbol{{ i }}"
                [(ngModel)]="sensorSetting.fl_DrippersTree"
                name="goterosArbol{{ i }}"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha{{ i }}"
                id="fecha{{ i }}"
                [(ngModel)]="sensorSettingsDates[i]"
                [matDatepicker]="pickerTime"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerTime"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerTime></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input
                matInput
                type="time"
                [(ngModel)]="sensorSettingsTimes[i]"
                name="hora{{ i }}"
              />
            </mat-form-field>

            <div class="col-sm-2 align-self-center relative-save flow-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
                <div class="col">
                  <small>{{ 'COMMON.DELETE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    (click)="saveSensorSetting(i)"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
                <div class="col">
                  <button
                    type="button"
                    (click)="deleteSensorSetting(sensorSetting.idSettings)"
                    mat-icon-button
                    color="warn"
                  >
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.DRIPPERS_PER_LINE' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="goterosLinea"
                [(ngModel)]="sensorGoterosLinea"
                name="goterosLinea"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.DRIPPERS_PER_TREE' | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                id="goterosArbol"
                [(ngModel)]="sensorGoterosArbol"
                name="goterosArbol"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-sm-2">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha"
                id="fecha"
                [(ngModel)]="sensorFecha"
                [matDatepicker]="sensorDateLegacy"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="sensorDateLegacy"
              ></mat-datepicker-toggle>
              <mat-datepicker #sensorDateLegacy></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input matInput type="time" [(ngModel)]="hora" name="hora" />
            </mat-form-field>

            <div class="col-sm-2 align-self-center relative-save flow-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    (click)="createSensorSetting()"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="editData.sensorType === 'ED'">
          <h6 class="mb-4">
            {{ 'TABLES.SENSOR_SETTINGS.DIGITAL_TITLE' | translate }}
          </h6>
          <div
            class="row"
            *ngFor="let sensorSetting of sensorSettings; let i = index"
          >
            <div class="col-sm-3 align-self-center">
              <mat-checkbox
                [(ngModel)]="sensorSettings[i].ed_invert"
                name="edInvert{{ i }}"
              >
                {{ 'TABLES.SENSOR_SETTINGS.DIGITAL_INVERT' | translate }}
              </mat-checkbox>
            </div>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha{{ i }}"
                id="fecha{{ i }}"
                [(ngModel)]="sensorSettingsDates[i]"
                [matDatepicker]="pickerED"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerED"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerED></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input
                matInput
                type="time"
                [(ngModel)]="sensorSettingsTimes[i]"
                name="hora{{ i }}"
              />
            </mat-form-field>

            <div class="col-sm-3 align-self-center relative-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
                <div class="col">
                  <small>{{ 'COMMON.DELETE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    (click)="saveSensorSetting(i)"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
                <div class="col">
                  <button
                    type="button"
                    (click)="deleteSensorSetting(sensorSetting.idSettings)"
                    mat-icon-button
                    color="warn"
                  >
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-3 align-self-center">
              <mat-checkbox [(ngModel)]="sensorEdInvert" name="edInvert">
                {{ 'TABLES.SENSOR_SETTINGS.DIGITAL_INVERT' | translate }}
              </mat-checkbox>
            </div>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{
                'TABLES.SENSOR_SETTINGS.INSTANT' | translate
              }}</mat-label>
              <input
                matInput
                placeholder="dd/mm/yyyy"
                name="fecha"
                id="fecha"
                [(ngModel)]="sensorFecha"
                [matDatepicker]="sensorDateED"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="sensorDateED"
              ></mat-datepicker-toggle>
              <mat-datepicker #sensorDateED></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-sm-3">
              <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
              <input matInput type="time" [(ngModel)]="hora" name="hora" />
            </mat-form-field>

            <div class="col-sm-3 align-self-center relative-save">
              <div class="row">
                <div class="col">
                  <small>{{ 'COMMON.SAVE' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button
                    type="button"
                    (click)="createSensorSetting()"
                    mat-flat-button
                    color="primary"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="isMoistureSensorType(editData.sensorType)">
          <section class="humidity-settings card">
            <header class="humidity-header">
              <h6>
                {{ 'TABLES.SENSOR_SETTINGS.HUMIDITY_PARAMS_TITLE' | translate }}
              </h6>
              <small class="hint">{{
                'TABLES.SENSOR_SETTINGS.HUMIDITY_HINT' | translate
              }}</small>
            </header>

            <div class="humidity-grid">
              <div
                class="humidity-row"
                *ngFor="let sensorSetting of sensorSettings; let i = index"
              >
                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.FIELD_CAPACITY' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    id="campo{{ i }}"
                    [(ngModel)]="sensorSettings[i].hu_lts"
                    name="campo{{ i }}"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.RECHARGE_POINT' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    id="recarga{{ i }}"
                    [(ngModel)]="sensorSettings[i].hu_lti"
                    name="recarga{{ i }}"
                  />
                </mat-form-field>

                <div class="h-checkbox-group" [class.e8-depths]="isEnviroproSensorType(editData.sensorType)">
                  <div class="h-checkbox-header">
                    <span
                      *ngFor="let label of getHumidityDepthLabels(editData.sensorType)"
                      >{{ label }}</span
                    >
                  </div>
                  <div class="h-checkbox-row">
                    <mat-checkbox
                      [(ngModel)]="sensorSettings[i].hu_h10"
                      name="h1{{ i }}"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorSettings[i].hu_h20"
                      name="h2{{ i }}"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorSettings[i].hu_h30"
                      name="h3{{ i }}"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorSettings[i].hu_h40"
                      name="h4{{ i }}"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorSettings[i].hu_h50"
                      name="h5{{ i }}"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorSettings[i].hu_h60"
                      name="h6{{ i }}"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <ng-container *ngIf="isEnviroproSensorType(editData.sensorType)">
                      <mat-checkbox
                        [(ngModel)]="sensorSettings[i].hu_h70"
                        name="h7{{ i }}"
                      ></mat-checkbox>
                      <mat-checkbox
                        [(ngModel)]="sensorSettings[i].hu_h80"
                        name="h8{{ i }}"
                      ></mat-checkbox>
                    </ng-container>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.DRAINAGE' | translate
                  }}</mat-label>
                  <mat-select
                    id="drenaje{{ i }}"
                    [(ngModel)]="sensorSettings[i].hu_sewerSystemType"
                    name="drenaje{{ i }}"
                  >
                    <mat-option
                      *ngFor="let sewer of getAvailableSewerSystemTypes(editData.sensorType)"
                      [value]="sewer.value"
                    >
                      {{ getSewerSystemTypeLabel(editData.sensorType, sewer.value) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{ 'COMMON.DATE' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerDyn"
                    [(ngModel)]="sensorSettingsDates[i]"
                    name="date{{ i }}"
                    id="date{{ i }}"
                    placeholder="dd/mm/yyyy"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerDyn"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerDyn></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
                  <input
                    matInput
                    type="time"
                    [(ngModel)]="sensorSettingsTimes[i]"
                    name="hora{{ i }}"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.CALIBRATION' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    id="calibration{{ i }}"
                    [(ngModel)]="sensorSettings[i].calibration"
                    name="calibration{{ i }}"
                  />
                </mat-form-field>

                <div class="action-cell">
                  <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="saveSensorSetting(i)"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    mat-icon-button
                    color="warn"
                    (click)="deleteSensorSetting(sensorSetting.idSettings)"
                    aria-label="Borrar"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

              <div class="humidity-row">
                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.FIELD_CAPACITY' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    id="campo"
                    [(ngModel)]="sensorCampo"
                    name="campo"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.RECHARGE_POINT' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    id="recarga"
                    [(ngModel)]="sensorRecarga"
                    name="recarga"
                  />
                </mat-form-field>

                <div class="h-checkbox-group" [class.e8-depths]="isEnviroproSensorType(editData.sensorType)">
                  <div class="h-checkbox-header">
                    <span
                      *ngFor="let label of getHumidityDepthLabels(editData.sensorType)"
                      >{{ label }}</span
                    >
                  </div>
                  <div class="h-checkbox-row">
                    <mat-checkbox
                      [(ngModel)]="sensorH1"
                      name="h1"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorH2"
                      name="h2"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorH3"
                      name="h3"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorH4"
                      name="h4"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorH5"
                      name="h5"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <mat-checkbox
                      [(ngModel)]="sensorH6"
                      name="h6"
                      *ngIf="!isSingleSoilHumiditySensorType(editData.sensorType)"
                    ></mat-checkbox>
                    <ng-container *ngIf="isEnviroproSensorType(editData.sensorType)">
                      <mat-checkbox
                        [(ngModel)]="sensorH7"
                        name="h7"
                      ></mat-checkbox>
                      <mat-checkbox
                        [(ngModel)]="sensorH8"
                        name="h8"
                      ></mat-checkbox>
                    </ng-container>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.DRAINAGE' | translate
                  }}</mat-label>
                  <mat-select
                    id="drenaje"
                    [(ngModel)]="sensorDrenaje"
                    name="drenaje"
                  >
                    <mat-option
                      *ngFor="let sewer of getAvailableSewerSystemTypes(editData.sensorType)"
                      [value]="sewer.value"
                    >
                      {{ getSewerSystemTypeLabel(editData.sensorType, sewer.value) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{ 'COMMON.DATE' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="sensorDate"
                    placeholder="dd/mm/yyyy"
                    name="date"
                    id="date"
                    [(ngModel)]="sensorFecha"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="sensorDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #sensorDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
                  <input matInput type="time" [(ngModel)]="hora" name="hora" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>{{
                    'TABLES.SENSOR_SETTINGS.CALIBRATION' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    id="calibration"
                    [(ngModel)]="sensorCalibracion"
                    name="calibration"
                  />
                </mat-form-field>

                <div class="action-cell">
                  <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="createSensorSetting()"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </section>
        </ng-container>
      </form>
    </mat-dialog-content>
  </ng-template>

  <ng-template #eventForm>
    <div class="modal-header bg-success">
      <h4 class="modal-title modal--title-event" id="modal-basic-title">
        {{ 'TABLES.EVENT.CONFIGURE' | translate }}
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeDialog()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="div--modal">
      <div class="row div--row mt-4" *ngFor="let event of events; index as i">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{
            'TABLES.PROJECT_MODULE.ID_MODULE' | translate
          }}</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="editData.idModule"
            name="idModule"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100 mt-3">
          <mat-label>{{ 'COMMON.DATE' | translate }}</mat-label>
          <input
            matInput
            [(ngModel)]="events[i].date"
            name="date"
            type="date"
            placeholder="dd/mm/yyyy"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
          <input
            matInput
            type="time"
            [(ngModel)]="events[i].time"
            name="eventTime{{ i }}"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100 mt-3">
          <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="events[i].comment"
            name="comment"
          />
        </mat-form-field>
        <div class="col-sm-2">
          <div class="row">
            <div class="col-auto">
              <small>{{ 'COMMON.SAVE' | translate }}</small>
            </div>
            <div class="col pl-2">
              <small>{{ 'COMMON.DELETE' | translate }}</small>
            </div>
          </div>
          <div class="row">
            <div class="col-auto">
              <button
                type="button"
                (click)="eventUpdate(event)"
                mat-flat-button
                color="primary"
              >
                <i class="fas fa-save"></i>
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                (click)="eventDelete(event.idEvent)"
                mat-icon-button
                color="warn"
              >
                <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="div--main">
      <form class="w-100 mx-auto" [formGroup]="eventModuleForm">
        <div class="row div--row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{
              'TABLES.PROJECT_MODULE.ID_MODULE' | translate
            }}</mat-label>
            <input
              matInput
              type="text"
              name="idModule"
              formControlName="idModule"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100 mt-3">
            <mat-label>{{ 'COMMON.DATE' | translate }}</mat-label>
            <input
              matInput
              name="date"
              type="date"
              placeholder="dd/mm/yyyy"
              formControlName="date"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'COMMON.TIME' | translate }}</mat-label>
            <input matInput type="time" formControlName="time" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100 mt-3">
            <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
            <input
              matInput
              type="text"
              name="comment"
              formControlName="comment"
            />
          </mat-form-field>
          <div class="col-sm-2">
            <div class="row">
              <div class="col-auto">
                <small>{{ 'COMMON.SAVE' | translate }}</small>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <button
                  type="button"
                  (click)="eventSave()"
                  mat-flat-button
                  color="primary"
                >
                  <i class="fas fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
</div>
